import Swiper from 'swiper';
import { Pagination, Navigation, Scrollbar } from 'swiper';

const setBlogSlider = () => {
  const targetSlides = document.querySelectorAll(".js-blog-slider");

  targetSlides.forEach(BlogSlider =>{
    if (window.innerWidth > 768){
      BlogSlider?.classList.remove('swiper-initialized');
      BlogSlider?.classList.remove('swiper-container');
      BlogSlider?.classList.add('slide-none');
      // const navButtons = BlogSlider.closest('.section-content')?.querySelector(".swiper-button-wrapper");
      // navButtons?.classList.add('slide-none');
      // const navBullet = BlogSlider.closest('.section-content')?.querySelector(".swiper-pagination");
      // navBullet?.classList.add('slide-none');
      return;
    }

    const slideLength = BlogSlider?.querySelectorAll(".swiper-slide").length;
    let windowWidth = BlogSlider?.clientWidth;
    let slideSize = 300;
    let slideSpace = 25
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

    const BlogSection = BlogSlider.closest('.section-blog')

    if(slideLength > viewSlideLength){
      var swiper = new Swiper(BlogSlider,{
        modules: [Pagination,Navigation,Scrollbar],
        speed: 500,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: slideSpace,
        // pagination: {
        //   el: BlogSection.querySelector('.swiper-pagination'),
        //   clickable: true,
        //   type: 'bullets',
        // },
        scrollbar: {
          el: BlogSection.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        navigation: {
          nextEl: BlogSection.querySelector('.swiper-button-next'),
          prevEl: BlogSection.querySelector('.swiper-button-prev'),
        },
      });

    } else{
      // BlogSlider?.classList.add('slide-none');
      // const navButtons = BlogSlider.closest('.section-content')?.querySelector(".swiper-button-wrapper");
      // navButtons?.classList.add('slide-none');
    }

    BlogSlider?.classList.add('is-init');

  });
}

export default setBlogSlider;